import type { DSButtonProps } from "@/src/design_system/button_and_controls/button/types/props";
import type {
  DSAriaLabelProps,
  DSFieldIdentityProps,
  DSSizingProps,
  DSStatefulProps,
} from "@/src/design_system/shared/types/props";
import { DS_SIZE } from "@/src/design_system/shared/types/size";
import type { ObjectValues } from "@/src/shared/types/objectValues";

export const DS_BUTTON_GROUP_SIZE = {
  Small: DS_SIZE.Small,
  Medium: DS_SIZE.Medium,
  Large: DS_SIZE.Large,
} as const;

export type DSButtonGroupSize = ObjectValues<typeof DS_BUTTON_GROUP_SIZE>;

export interface DSButtonGroupOption extends Pick<
  DSButtonProps,
  "prefixIcon" | "suffixIcon" | "ariaLabel" | "disabled"
> {
  value: string;
  label?: string;
}

export interface DSButtonGroupProps
  extends
    DSSizingProps<DSButtonGroupSize>,
    Pick<DSStatefulProps, "disabled">,
    DSFieldIdentityProps,
    Required<Pick<DSAriaLabelProps, "ariaLabel">>,
    Pick<DSAriaLabelProps, "ariaDescribedBy"> {
  options: DSButtonGroupOption[];
}
